import {tagAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

import borders from 'airship/design-system/theme/foundations/borders'
import colors from 'airship/design-system/theme/foundations/colors'
import size from 'airship/design-system/theme/foundations/sizes'

import typography from '../foundations/typography'

const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(tagAnatomy.keys)

const baseStyle = definePartsStyle({
  container: {
    borderRadius: borders.radii['2xs'],
    minWidth: size.sm,
    ...typography.textStyles.body.small,
  },
})

const solidBlue = definePartsStyle({
  container: {
    bg: colors.background.accent.blue,
    color: 'white',
  },
})

const solidCyan = definePartsStyle({
  container: {
    bg: colors.background.accent.cyan,
    color: 'white',
  },
})

const solidPurple = definePartsStyle({
  container: {
    bg: colors.background.accent.purple,
    color: 'white',
  },
})

const solidPink = definePartsStyle({
  container: {
    bg: colors.background.accent.pink,
    color: 'white',
  },
})

const solidRed = definePartsStyle({
  container: {
    bg: colors.background.accent.red,
    color: 'white',
  },
})

const solidOrange = definePartsStyle({
  container: {
    bg: colors.background.accent.orange,
    color: 'white',
  },
})

const solidYellow = definePartsStyle({
  container: {
    bg: colors.background.accent.yellow,
    color: 'white',
  },
})

const solidGreen = definePartsStyle({
  container: {
    bg: colors.background.accent.green,
    color: 'white',
  },
})

const solidTeal = definePartsStyle({
  container: {
    bg: colors.background.accent.teal,
    color: 'white',
  },
})

const solidCoolGray = definePartsStyle({
  container: {
    bg: colors.background.accent['cool-gray'],
    color: 'white',
  },
})

const solidGray = definePartsStyle({
  container: {
    bg: colors.background.accent.gray,
    color: 'white',
  },
})

const subtleBlue = definePartsStyle({
  container: {
    bg: colors.background.accent['blue-secondary'],
    color: colors.text.accent.blue,
  },
})

const subtleCyan = definePartsStyle({
  container: {
    bg: colors.background.accent['cyan-secondary'],
    color: colors.text.accent.cyan,
  },
})

const subtlePurple = definePartsStyle({
  container: {
    bg: colors.background.accent['purple-secondary'],
    color: colors.text.accent.purple,
  },
})

const subtlePink = definePartsStyle({
  container: {
    bg: colors.background.accent['pink-secondary'],
    color: colors.text.accent.pink,
  },
})

const subtleRed = definePartsStyle({
  container: {
    bg: colors.background.accent['red-secondary'],
    color: colors.text.accent.red,
  },
})

const subtleOrange = definePartsStyle({
  container: {
    bg: colors.background.accent['orange-secondary'],
    color: colors.text.accent.orange,
  },
})

const subtleYellow = definePartsStyle({
  container: {
    bg: colors.background.accent['yellow-secondary'],
    color: colors.text.accent.yellow,
  },
})

const subtleGreen = definePartsStyle({
  container: {
    bg: colors.background.accent['green-secondary'],
    color: colors.text.accent.green,
  },
})

const subtleTeal = definePartsStyle({
  container: {
    bg: colors.background.accent['teal-secondary'],
    color: colors.text.accent.teal,
  },
})

const subtleCoolGray = definePartsStyle({
  container: {
    bg: colors.background.accent['cool-gray-secondary'],
    color: colors.text.accent['cool-gray'],
  },
})

const subtleGray = definePartsStyle({
  container: {
    bg: colors.background.accent['gray-secondary'],
    color: colors.text.accent.gray,
  },
})

const tagTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    solidBlue,
    solidCyan,
    solidPurple,
    solidPink,
    solidRed,
    solidOrange,
    solidYellow,
    solidGreen,
    solidTeal,
    solidCoolGray,
    solidGray,
    subtleBlue,
    subtleCyan,
    subtlePurple,
    subtlePink,
    subtleRed,
    subtleOrange,
    subtleYellow,
    subtleGreen,
    subtleTeal,
    subtleCoolGray,
    subtleGray,
  },
  defaultProps: {
    variant: 'solidBlue',
  },
})

export default tagTheme
